import { useTranslation } from 'react-i18next';
import {
    FaPlus,
    FaMinus,
    FaExclamation,
    FaDownload,
    FaAngleRight,
    FaTrash,
} from 'react-icons/fa';
import {
    bgColorOptions,
    borderColorOptions,
    textColorOptions,
    DefaultButtonV2Props,
} from 'components/buttonV2/interface';
import Loading from 'assets/images/loading.gif';

const DefaultButtonV2: React.FC<DefaultButtonV2Props> = ({
    buttonText,
    icon,
    iconSize,
    textColor = 'white',
    bgColor = 'blue',
    textSize = 'text-sm',
    hasborder = false,
    bordercolor = 'gray',
    padding = false,
    disabled = false,
    marginLeft = false,
    marginRight = false,
    onClick,
    showLoader = false,
    title = '',
    className = '',
    type = 'button',
    form,
    small = false,
    fullWidth,
    endIcon,
    dataElement = '',
}) => {
    const { t } = useTranslation();

    const buttonSizeClasses = small
        ? `px-3 py-2 h-9 text-sm ${fullWidth ? 'w-full' : 'w-auto'}`
        : `px-3 py-2.5 h-10 ${
              fullWidth ? 'w-full' : padding ? 'w-52' : 'w-40'
          }`;

    const iconProps = { size: iconSize ?? 14, className: 'ml-2' };

    const iconElement =
        icon === 'plus' ? (
            <FaPlus data-testid="FaPlus" {...iconProps} />
        ) : icon === 'minus' ? (
            <FaMinus {...iconProps} />
        ) : icon === 'exclamation' ? (
            <FaExclamation {...iconProps} />
        ) : icon === 'download' ? (
            <FaDownload {...iconProps} />
        ) : icon === 'angleRight' ? (
            <FaAngleRight {...iconProps} />
        ) : icon === 'trash' ? (
            <FaTrash {...iconProps} />
        ) : null;

    return (
        <button
            data-element={`${dataElement}`}
            type={type ?? 'button'}
            form={form}
            disabled={disabled}
            title={title}
            onClick={(event) => onClick?.(event)}
            className={`
                ${buttonSizeClasses}
                shadow rounded-md leading-4 ${textSize}
                flex items-center justify-center
                hover:shadow-md transition-[opacity,shadow] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
                ${hasborder ? 'border border-indigo-600' : ''}
                ${borderColorOptions[bordercolor]}
                ${bgColorOptions[bgColor]}
                ${textColorOptions[textColor]}
                ${marginLeft ? 'ml-4' : ''}
                ${marginRight ? 'mr-4' : ''}
                ${className}
                disabled:bg-pk-light-grey
                disabled:text-black
                disabled:cursor-not-allowed
                disabled:hover:shadow-none
                disabled:opacity-100
            `}
        >
            {showLoader ? (
                <div className="flex items-center">
                    <img
                        src={Loading}
                        className="w-5 h-4 pr-1 mt-0.5"
                        alt="loader"
                    />
                    {t(buttonText)}
                    {iconElement}
                    {endIcon && endIcon}
                </div>
            ) : (
                <div className="flex items-center">
                    {t(buttonText)}
                    {iconElement}
                    {endIcon && endIcon}
                </div>
            )}
        </button>
    );
};
//
DefaultButtonV2.displayName = 'DefaultButtonV2';
export default DefaultButtonV2;
